export default __webpack_public_path__ + "static/media/WiCSBackGround.504e15d4.png";